<template>
	<div class="lzWps">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false" top="1vh">
			<div slot="title" class="header">
				<div class="title">在线预览</div>
				<div class="fileName">{{dialog.fileName}}</div>
				<div class="btn">
					<div class="b1" @click="download"><i class="icon el-icon-download"></i>下载</div>
					<div class="b1" @click="dialog.show=false"><i class="icon el-icon-close" ></i>关闭</div>
				</div>
			</div>
			<div id="lzwps" style="width: 100%;height:95vh;">
				<div v-if="isIp.show" style="width: 100%;height: 100%;" v-loading="isIp.loading" class="ip" element-loading-text="拼命加载中" element-loading-background="rgba(70, 70, 70, 0.8)">
					<div ref="file" id="fileid" style="width: 100%;height: 100%;overflow: auto;" v-show="dialog.fileType=='docx'||dialog.fileType=='doc'"></div>
					<lzExcel :datas="excel.data" v-show="dialog.fileType=='xlsx'||dialog.fileType=='xls'"></lzExcel>
				</div>
				<iframe :src="dialog.url" frameborder="0" style="width: 100%;height:100%;" v-else></iframe>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'
	let docx = require("docx-preview");
	import lzExcel from '@/components/lzExcel/lzExcel'
	import config from './config.js'
	
	export default {
		computed: {
			...mapGetters(['api','userInfo']),
		},
		components:{
			lzExcel
		},
		name: 'lzWps',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
			filePath: {
				type: String,
				default: ''
			},
			fileId: {
				type: String,
				default: ''
			},
			fileName: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				dialog:{
					show:false,
					url:'',
					fileName:'',
					fileId:'',
					fileUrl:'',
					fileType:'word'
				},
				isIp:{
					show:false,
					loading:true,
				},
				excel:{
					data:""
				}
			}
		},
		mounted() {
			that =this
		},
		methods: {
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			submitFn(){
				this.confirm(true)
			},
			show(data){
				this.dialog.show=true
				this.dialog.fileName=data.fileName
				this.dialog.fileUrl=this.api.GLOBAL_HOST_IMAGE + data.filePath + '?Authorization='+this.userInfo.token
				let index= data.fileName.lastIndexOf('.')
				let suf=data.fileName.slice(index+1,data.fileName.length)
				this.dialog.fileType=suf
				let type=this.$lizhao.file.lzGetTypeSuffix(suf)
				if(type=='word'){
					if(suf=='pdf'){
						this.dialog.url=this.dialog.fileUrl+'&download=0'
						return
					}
					//若是私有化或者ip形式，自行判断
					if(this.checkdomain()==false||config.whiteList.includes(document.domain)){
						this.isIp.show=true
						if(suf=='docx'||suf=='doc'){
							this.docxFn()
						}else if(suf=='xlsx'||suf=='xls'){
							this.excelFn()
						}
						return
					}
					// 若不是ip形式，直接使用免费的接口
					this.isIp.show=false
					//由于免费的在线查看，不支持ip+端口的形式所以单独处理
					this.dialog.url='http://view.officeapps.live.com/op/view.aspx?src='+ encodeURIComponent(this.dialog.fileUrl);
				}
			},
			excelFn(){
				this.isIp.loading=true
				that.GLOBAL.doBlob(this.api.GLOBAL_file_fileInfo_downloadNoneNeedAccess+'/'+this.fileId,{responseType:'arraybuffer'},(res) => {
					this.excel.data = res.body
					this.isIp.loading=false
				})
			},
			docxFn(){
				this.isIp.loading=true
				that.GLOBAL.doBlob(this.api.GLOBAL_file_fileInfo_downloadNoneNeedAccess+'/'+this.fileId,{responseType:'blob'},(res) => {
					docx.renderAsync(res.body, this.$refs.file); // 渲染到页面
					this.isIp.loading=false
				})
			},
			download(){
				window.location.href=this.dialog.fileUrl
			},
			handclose(){
				this.close()
			},
			//验证是否是域名
			checkdomain(){
			    let doname = /^([\w-]+\.)+((com)|(net)|(org)|(gov\.cn)|(info)|(cc)|(com\.cn)|(net\.cn)|(org\.cn)|(name)|(biz)|(tv)|(cn)|(mobi)|(name)|(sh)|(ac)|   (io)|(tw)|(com\.tw)|(hk)|(com\.hk)|(ws)|(travel)|(us)|(tm)|(la)|(me\.uk)|(org\.uk)|(ltd\.uk)|(plc\.uk)|(in)|(eu)|(it)|(jp))$/;
			    let flag_domain = doname.test(document.domain);
			    if(!flag_domain){//错误的域名
			        return false
			    }else{
			        return true
			    }
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:0;
	}
	/deep/ .el-dialog__wrapper{
		overflow: hidden;
	}
	/deep/ .el-dialog__header{
		padding: 0;
	}
	/deep/ .el-dialog__headerbtn{
		display: none;
	}
	.lzWps {
		.header{
			background-color: #f0f0f0;padding: 10px;display: flex;position: relative;
			.title{
				// color: #00aa7f;
			}
			.fileName{
				text-align: center;width: 90%;
			}
			.btn{
				position: absolute;right: 20px;color: #00aa7f;display: flex;
				.b1{
					cursor: pointer;font-size: 12px;margin-left: 10px;
					display: flex;align-items: center;
					.icon{
						font-size: 16px;font-weight: bold;
					}
				}
			}
		}
		.center{
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lzWps/lzWps.vue